
<template>
  <div class="userlist">
    <div class="top">
        <div class="title">我的线索推荐</div>
        <div class="timer">
            <div class="timer-val" @click="showDate">{{currentDateshow}} <img src="../../assets/images/new/arrow.png" alt=""> </div>
            <div class="timer-box" v-if="timerInfo.show">

                <van-datetime-picker
                v-model="currentDate"
                type="year-month"
                title="选择年月"
                @confirm='getNewDate'
                />
            </div>
        </div>
    </div>
    <div class="main">
        <div class="list-box" v-if="list.length>0">
            <div class="each-item flex-b-c" v-for="item in list" :key='item.clueContactPhone'>
                <div class="phone">{{item.clueContactPhone}}</div>
                <div class="type-img">
                    {{clueStatusDic[item.clueStatus]}}
                    <!-- <img src="../../assets/images/new/enable.png" v-if="item.clueStatus==3" alt="">
                    <img src="../../assets/images/new/unable.png" v-else alt=""> -->
                </div>
            </div>
        </div>
        <div class="no-data flex-c-c" v-else>暂无数据</div>
    </div>
  </div>
</template>

<script type="text/babel">
// 组件
export default {
  name: 'userList',
  data() {
    return {
        username:"",
        currentDate:'' ,
        currentDateshow:"",
        formatter:'',
        clueStatusDic:{
            1:"线索客户",
            2:"试用中",
            3:"已购买"
        },
        list:[],
        timerInfo:{
            show:false
        }
    };
  },
  created() {
    this.currentDateshow = this.setDefaultDate('')
    this.currentDate = new Date() 
    this.getList()
  },
  methods: {
    setDefaultDate(time) {
        let nowDate =''
        if(time) {

            nowDate = new Date(time)
        } else {
            nowDate = new Date()

        }
        let year = nowDate.getFullYear()
        let month = nowDate.getMonth()+1
        month = month>10?month:("0"+month)
        return year+'-'+month
    },
    showDate() {
        this.timerInfo.show=true
    },
    getNewDate(e) {
        console.log(e, this.currentDate)
        this.currentDateshow = this.setDefaultDate(e)
        this.timerInfo.show=false
        this.getList()
    },
    getList() {
        
        this.currentDateshow = this.setDefaultDate(this.currentDate)
        let param = {
            dateTime: this.currentDateshow
        }
        this.$services.customerClues({
            method:'POST',
            data:param
        }).then(res=> {
            if(res.code==0) {
                this.list = res.data
            }
        })
    }
  }
  }
</script>

<style lang="less" scoped>
.userlist{
    .no-data{
        min-height: 400px;
    }
    .top{
        height: 120px;
        background-color: #FEF3E5;
        padding-top: 30px;
        padding: 30px 14px 0 14px;
        .title{
            font-size: 18px;
            color: #000;
            margin-bottom: 38px;
        }
        .timer-val{
            text-align: left;
            img{
                width: 10px;
                height: 6px;
                margin-left: 6px;
            }
        }
    }
    .list-box{
        padding: 20px 14px;
        .each-item{
            padding: 8px 0;
            border-bottom: 1px solid;
            border-color: rgba(0,0,0, 0.2);
            .phone{
                font-size: 18px;
                font-family: Noto Sans S Chinese;
                font-weight: 500;
                color: #000000;
            }
            .type-img{
                padding: 4px 10px;
                border-radius: 20px;
                background-color: #FFE953;
                overflow: hidden;
                img{
                    width: 106px;
                    height: 31px;
                }
            }
        }
    }
}
</style>
 